import {Component, Material, MeshComponent, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Cursor} from '@wonderlandengine/components';

export enum CursorType {
    Default,
    Pointer,
    Magnify,
    Door,
    NextPage,
    PreviousPage,
}
/**
 * cursor-reticle
 */
export class CursorReticle extends Component {
    static TypeName = 'cursor-reticle';
    /* Properties that are configurable in the editor */
    @property.object()
    cursorLeftMesh?: Object3D;

    @property.object()
    cursorRightMesh?: Object3D;

    /* Cursor Textures */
    @property.material()
    cursorDefault?: Material;
    @property.material()
    cursorPointer?: Material;
    @property.material()
    cursorMagnify?: Material;
    @property.material()
    cursorDoor?: Material;
    @property.material()
    cursorNextPage?: Material;
    @property.material()
    cursorPreviousPage?: Material;

    private leftMeshComponent?: MeshComponent;
    private rightMeshComponent?: MeshComponent;

    start(): void {
        if (!this.cursorLeftMesh) {
            throw new Error('CursorReticle: cursorLeftMesh is not set');
        }
        const tempLeftMeshComponent = this.cursorLeftMesh.getComponent(MeshComponent);
        if (!tempLeftMeshComponent) {
            throw new Error('CursorReticle: cursorLeftMesh does not have a MeshComponent');
        }
        this.leftMeshComponent = tempLeftMeshComponent;

        if (!this.cursorRightMesh) {
            throw new Error('CursorReticle: cursorRightMesh is not set');
        }
        const tempRightMeshComponent = this.cursorRightMesh.getComponent(MeshComponent);
        if (!tempRightMeshComponent) {
            throw new Error('CursorReticle: cursorRightMesh does not have a MeshComponent');
        }
        this.rightMeshComponent = tempRightMeshComponent;

        this.engine.canvas.style.cursor = "url('icons/reticle.png') 32 32, auto";
    }

    changeCursorTexture(cursor: Cursor, type: CursorType): void {
        let material: Material;
        switch (type) {
            case CursorType.Pointer:
                material = this.cursorPointer!;
                this.engine.canvas.style.cursor =
                    "url('icons/interaction_manipulate.png') 32 32, auto";
                break;
            case CursorType.Magnify:
                material = this.cursorMagnify!;
                this.engine.canvas.style.cursor =
                    "url('icons/interaction_investigate.png') 32 32, auto";
                break;
            case CursorType.Door:
                material = this.cursorDoor!;
                this.engine.canvas.style.cursor =
                    "url('icons/interaction_door.png') 32 32, auto";
                break;
            case CursorType.NextPage:
                material = this.cursorNextPage!;
                this.engine.canvas.style.cursor =
                    "url('icons/interaction_nextPage.png') 32 32, auto";
                break;
            case CursorType.PreviousPage:
                material = this.cursorPreviousPage!;
                this.engine.canvas.style.cursor =
                    "url('icons/interaction_prevPage.png') 32 32, auto";
                break;
            case CursorType.Default:
            default:
                material = this.cursorDefault!;
                this.engine.canvas.style.cursor = "url('icons/reticle.png') 32 32, auto";
                break;
        }

        this.leftMeshComponent!.material = material;
        this.rightMeshComponent!.material = material;
    }
}
